import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'aggSum'
})
export class AggSumPipe implements PipeTransform {
  transform(groupItems: any[]): any {
        let aggSumVal = 0;

        for (var i = 0; i < groupItems.length; i++) {
       //   if (groupItems[i].productCategory === productCategory) {
            let chk = this.convertNum(groupItems[i].primaryContractValue.value);
            aggSumVal = aggSumVal + chk;
      //    }
            // else
            // aggSumVal = aggSumVal + parseFloat(groupItems[i].primaryContractValue.value);
        }
        return aggSumVal;
  }
  convertNum(val){
    let retVal:any = parseFloat(val).toString()
    if(retVal === 'NaN')
    retVal = 0.00;
    else
    retVal = parseFloat(retVal);
    return retVal;
  }
}
